exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EditorColumn-43278df3{height:100%;margin:38px 0px 40px 0px;display:flex;flex-direction:column}.emptyEditor-dc224a63{height:500px;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#9E9E9E}.editorCard-fc29b61d{padding-top:16px}.savedAt-d986917c{opacity:0.6;font-size:13px;padding-bottom:15px}.title-6612b19e{padding-bottom:10px}.guideTitle-2f870425{font-size:15px;margin-bottom:20px}.guideTitle-2f870425.header-95ca3354{margin-bottom:0px}.guideTitle-2f870425 form{display:flex;align-items:flex-start}.guideTitle-2f870425 form input{flex-grow:1;min-width:0px;height:42px;margin:0px}.guideTitle-2f870425 form>button{margin:0px 0px 0px 20px}\n", ""]);

// Exports
exports.locals = {
	"EditorColumn": "EditorColumn-43278df3",
	"emptyEditor": "emptyEditor-dc224a63",
	"editorCard": "editorCard-fc29b61d",
	"savedAt": "savedAt-d986917c",
	"title": "title-6612b19e",
	"guideTitle": "guideTitle-2f870425",
	"header": "header-95ca3354"
};